import { createContext, useContext, useState } from 'react'
import ToastContainer from '../components/toast/ToastContainer'

const ToastContext = createContext(undefined)

export const useToast = () => {
    const context = useContext(ToastContext)
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider')
    }
    return context
}

let toastId = 0

const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([])
    const [toastPosition, setToastPosition] = useState('bottom')

    const showToast = (props) => {
        const { title, type = 'info', message, position = 'bottom' } = props
        const newToast = {
            id: toastId++,
            type,
            message,
            title,
        }

        setToasts((prevToasts) => [...prevToasts, newToast])
        setToastPosition(position)

        setTimeout(() => {
            hideToast(newToast.id)
        }, 6000)
    }

    const hideToast = (id) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id))
    }

    return (
        <ToastContext.Provider value={{ showToast, hideToast }}>
            {children ?? null}
            <ToastContainer
                toasts={toasts}
                position={toastPosition}
                hideToast={hideToast}
            />
        </ToastContext.Provider>
    )
}

export default ToastProvider
